import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { object, string } from "yup";
import { actionCreators } from "../redux/userProfileSagas";
import { Input } from "../../../components/form/Input/Input";
import ToggleableButton from "../../../components/toggleableButton/toggleableButton";
import { ErrorList } from "../../../components/ErrorList";

const schema = object({
  first_name: string().label("First Name").trim().min(2).required(),
  last_name: string().label("Last Name").trim().min(2).required()
}).required();

const EditForm = () => {
  const dispatch = useDispatch();
  const { user, isSaving, errors: serverErrors } = useSelector((state) => state.userProfile);

  const dailyEmailSettings = user.daily_email_settings || {};
  const showToggle = !!dailyEmailSettings.show_toggle;

  const {
    register,
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema),
    values: {
      first_name: user.first_name || "",
      last_name: user.last_name || "",
      ...(showToggle ? { separate_daily_email: !!dailyEmailSettings.separate_daily_email } : {})
    }
  });

  const onSubmit = (data) => {
    dispatch(actionCreators.submitProfile({ ...data, showToggle }));
  };

  return (
    <div className="form-inner">
      <form className="user-profile-form" onSubmit={handleSubmit(onSubmit)}>
        <div className="user-profile-form__fields">
          <Input label="First Name" htmlFor="first_name" customProps={register("first_name")} />
          <Input label="Last Name" htmlFor="last_name" customProps={register("last_name")} />

          {showToggle && (
            <div className="switch">
              <p className="switch__title">Daily email for each store</p>
              <Controller
                control={control}
                name="separate_daily_email"
                render={({ field: { onChange, value } }) => (
                  <div className={`switch__content ${value ? "switch__content--active" : ""}`}>
                    <ToggleableButton
                      isRadio
                      title="separate_daily_email"
                      isActive={value}
                      onClick={(isActive) => onChange(isActive)}
                    />
                  </div>
                )}
              />
            </div>
          )}
        </div>

        <div className="user-profile-form__actions">
          <ErrorList errors={{ ...errors, ...(serverErrors ? { profile: serverErrors } : {}) }} />

          <button type="submit" className="btn-session" disabled={isSaving}>
            {isSaving ? "Saving..." : "Save Profile"}
          </button>
          <a href="/" className="option-link">
            Back to Dashboard
          </a>
        </div>
      </form>
    </div>
  );
};

export default EditForm;
